import { useCallback } from 'react';
import { useTracker } from '@archipro-website/tracker';

/**
 * Shared search event tracking used by Rocco search UI across web and BM.
 */
export function useSearchTracking() {
    const tracker = useTracker();

    const onPerformSearch = useCallback(
        (query: string) => {
            void tracker.log('PerformSearch', {
                url: new URL(window.location.href),
                data: {
                    ExtraData: query,
                },
            });
        },
        [tracker],
    );

    const onSearchSuggestionClick = useCallback(
        (query: string) => {
            void tracker.log('SearchSuggestionClick', {
                url: new URL(window.location.href),
                data: {
                    ExtraData: query,
                },
            });
        },
        [tracker],
    );

    const onRecentSearchClick = useCallback(
        (query: string) => {
            void tracker.log('RecentSearchClick', {
                url: new URL(window.location.href),
                data: {
                    ExtraData: query,
                },
            });
        },
        [tracker],
    );

    const onSuggestedCategoryClick = useCallback(
        (title: string) => {
            void tracker.log('SearchSuggestedCategoryClick', {
                url: new URL(window.location.href),
                data: {
                    ExtraData: title,
                },
            });
        },
        [tracker],
    );

    const onSearchTrendingClick = useCallback(
        (title: string) => {
            void tracker.log('SearchTrendingClick', {
                url: new URL(window.location.href),
                data: {
                    ExtraData: title,
                },
            });
        },
        [tracker],
    );

    return {
        onPerformSearch,
        onSearchSuggestionClick,
        onRecentSearchClick,
        onSuggestedCategoryClick,
        onSearchTrendingClick,
    };
}
